import { d as t, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as l, createElementBlock as s, normalizeClass as r, normalizeStyle as n, createElementVNode as c } from "vue";
const a = t("star-fill"), i = /* @__PURE__ */ c("path", {
  d: "m908.1 353.1-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3-12.3 12.7-12.1 32.9.6 45.3l183.7 179.1-43.4 252.9c-1.2 6.9-.1 14.1 3.2 20.3 8.2 15.6 27.6 21.7 43.2 13.4L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, f, _, d, u, h) {
  return l(), s("svg", {
    class: r(e.classes),
    style: n(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const v = /* @__PURE__ */ o(a, [["render", m]]);
export {
  v as default
};
